// extracted by mini-css-extract-plugin
export default {"columnCtaContainer":"Column_columnCtaContainer__pxxum","getAppsCtaContainer":"Column_getAppsCtaContainer__qgRyr","placeHolderContainer":"Column_placeHolderContainer__hf5js"};